module.exports = __webpack_public_path__ + "img/Japan.db1e3fb2.svg";